module.exports = __webpack_public_path__ + "static/media/category.2b21e3cf.svg";